/** Estimativa de tempo de leitura (200 palavras/minuto). */

export const READING_WPM = 200;

export function estimateReadingTimeMinutes(text: string): number {
  const cleaned = text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  const words = cleaned ? cleaned.split(' ').filter(Boolean).length : 0;
  if (words === 0) return 1;
  return Math.max(1, Math.round(words / READING_WPM));
}

export function formatReadingTimeLabel(minutes: number): string {
  const value = Math.max(1, Math.round(minutes));
  return value === 1 ? '1 minuto' : `${value} minutos`;
}
